import React from 'react'
import styled from '@emotion/styled'
import { IconProps } from '../../models/IconProps'
const BaseComponent = ({ size = 24, tabIndex = -1, focusable = false, ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      height={size}
      width={size}
      tabIndex={tabIndex}
      focusable={focusable}
      fill="currentColor"
      {...props}
    >
      <rect
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={32}
        x={280.48}
        y={122.9}
        width={63.03}
        height={378.2}
        rx={31.52}
        transform="translate(-129.23 312) rotate(-45)"
      />
      <path d="M178.38,178.38h0a31.64,31.64,0,0,0,0,44.75L223.25,268,268,223.25l-44.87-44.87A31.64,31.64,0,0,0,178.38,178.38Z" />
      <line
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={32}
        strokeLinecap="round"
        x1={48}
        y1={192}
        x2={96}
        y2={192}
      />
      <line
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={32}
        strokeLinecap="round"
        x1={90.18}
        y1={90.18}
        x2={124.12}
        y2={124.12}
      />
      <line
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={32}
        strokeLinecap="round"
        x1={192}
        y1={48}
        x2={192}
        y2={96}
      />
      <line
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={32}
        strokeLinecap="round"
        x1={293.82}
        y1={90.18}
        x2={259.88}
        y2={124.12}
      />
      <line
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={32}
        strokeLinecap="round"
        x1={124.12}
        y1={259.88}
        x2={90.18}
        y2={293.82}
      />
    </svg>
  )
}
export default styled(BaseComponent)`
  outline: none;
`
